import { computed } from 'vue'
import { useAppStore } from '../stores/app'

/**
 * 组合式函数：提供翻译功能
 */
export function useI18n() {
  const appStore = useAppStore()
  
  // 当前语言
  const language = computed(() => appStore.userPreferences.language)
  
  // 翻译数据响应式引用
  const translations = computed(() => appStore.translations)
  
  // 创建响应式翻译函数
  const t = (key: string, params?: Record<string, any>) => {
    // 直接返回计算属性
    return computed(() => {
      const currentTranslations = translations.value
      
      // 如果翻译尚未加载，静默返回键
      if (!currentTranslations || typeof currentTranslations !== 'object' || Object.keys(currentTranslations).length === 0) {
        return key
      }
      
      const keys = key.split('.')
      let value: any = currentTranslations
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k]
        } else {
          // 仅在翻译已加载但键缺失时警告
          if (Object.keys(currentTranslations).length > 0) {
            console.warn(`Translation key "${key}" not found in language ${appStore.userPreferences.language}`)
          }
          return key
        }
      }
      
      // 替换参数（仅当值为字符串时）
      if (params && typeof value === 'string') {
        value = value.replace(/\{(\w+)\}/g, (match, paramKey) => {
          return params[paramKey] !== undefined ? String(params[paramKey]) : match
        })
      }
      return value
    })
  }

  // 切换语言
  const switchLanguage = async (lang: string) => {
    await appStore.switchLanguage(lang)
  }

  return {
    language,
    t,
    switchLanguage
  }
}